import { render, staticRenderFns } from "./StaffAddCustomer.vue?vue&type=template&id=5c294910&"
import script from "./StaffAddCustomer.vue?vue&type=script&lang=js&"
export * from "./StaffAddCustomer.vue?vue&type=script&lang=js&"
import style0 from "./StaffAddCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports